import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';

import objectUtils from '~/utils/objects';

export default function useCrudQuery<TParams extends Record<string, any>, TResponse>(
  params: Ref<TParams>,
  queryKey: string,
  queryFn: (_requestParams: TParams) => Promise<TResponse>,
) {
  const queryKeyComputed = computed(() => [queryKey, objectUtils.objectParamsToString(params.value)]);

  return useQuery({
    queryFn: () => queryFn(params.value),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeyComputed,
  });
}
